const setPersonalDetailField = payload => ({
  type: "SET_PERSONAL_DETAIL_FIELD",
  payload
});

const setResidenceField = payload => ({
  type: "SET_RESIDENCE_FIELD",
  payload
});

const setEmployerField = payload => ({
  type: "SET_EMPLOYER_FIELD",
  payload
});

const setNextOfKinField = payload => ({
  type: "SET_NEXTOFKIN_FIELD",
  payload
});

const setBankDetailsField = payload => ({
  type: "SET_BANK_DETAILS_FIELD",
  payload
});

const setPictureField = payload => ({
  type: "SET_PICTURE_FIELD",
  payload
});

const setSignatureField = payload => ({
  type: "SET_SIGNATURE_FIELD",
  payload
});

const setConsentFormField = payload => ({
  type: "SET_CONSENT_FORM_FIELD",
  payload
});

const getUser = payload => ({
  type: "GET_USER",
  payload
});

const saveCountries = payload => ({
  type: "SAVE_COUNTRIES",
  payload
});

const resetOnboardingForm = () => ({
  type: "RESET_ONBOARDING_FORM"
});

export default {
  setPersonalDetailField,
  setResidenceField,
  setEmployerField,
  setNextOfKinField,
  setBankDetailsField,
  setPictureField,
  setSignatureField,
  setConsentFormField,
  getUser,
  saveCountries,
  resetOnboardingForm
};
